import { i18n } from '@/i18n'
import store from '@/store'


export default (params) => {
  const hasIssuedInvoice = store.getters['auth/hasIssuedInvoiceModule']
  const hasReceivedInvoice = store.getters['auth/hasReceivedInvoiceModule']
  const hasVerifactu = store.getters['auth/hasVerifactuModule']
  const issuedPanel = {
    name: i18n.t('invoices.issued_header'),
    path: 'financialdashboard/issued',
    params,
    use_parent_params: true,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  const receivedPanel = {
    name: i18n.t('invoices.received_header'),
    path: 'financialdashboard/received',
    params,
    use_parent_params: true,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  const verifactuPanel = {
    name: i18n.t('tipos.modulo_name.verifactu'),
    path: 'financialdashboard/verifactu',
    params,
    use_parent_params: true,
    registerNavFromMenu: false,
  }
  const taxesPanel = {
    name: i18n.t('financial_dashboard.settlement'),
    path: 'financialdashboard/taxes',
    params,
    use_parent_params: true,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  const menu = [
    {
      menuId: 19,
      icon: 'issued',
      name: i18n.t('app.ppal'),
      path: 'financialdashboard',
      params,
      use_parent_params: true,
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('financial_dashboard.general_panel'),
          path: 'financialdashboard/general',
          params,
          use_parent_params: true,
          registerNavFromMenu: false,
        }
      ]
    },
    {
      menuId: 20,
      icon: 'verifactu',
      name: i18n.t('financial_dashboard.fiscal'),
      path: 'financialdashboard/fiscal',
      params,
      use_parent_params: true,
      registerNavFromMenu: false,
      sc: []
    },
    {
      menuId: 21,
      icon: 'bell',
      name: i18n.t('app.icons.alerts'),
      path: 'financialdashboard/warning',
      params,
      use_parent_params: true,
      registerNavFromMenu: false,
      sc: []
    },
  ]
  if (hasIssuedInvoice) {
    menu[0].sc.push(issuedPanel)
  }
  if (hasReceivedInvoice) {
    menu[0].sc.push(receivedPanel)
  }
  if (hasVerifactu) {
    menu[1].sc.push(verifactuPanel)
  }
  menu[1].sc.push(taxesPanel)
  return menu
}
